import { z } from 'zod';

export const ResetPasswordSchema = z.object({
  password: z.string().min(8, 'Password minimal 8 character'),
});

export type ResetPasswordModel = z.infer<typeof ResetPasswordSchema>;
